import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=4bc62357&scoped=true&"
import script from "./Home3.vue?vue&type=script&lang=js&"
export * from "./Home3.vue?vue&type=script&lang=js&"
import style0 from "./Home3.vue?vue&type=style&index=0&id=4bc62357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc62357",
  null
  
)

export default component.exports